import { render, staticRenderFns } from "./newPie.vue?vue&type=template&id=d22971e2&scoped=true&"
import script from "./newPie.vue?vue&type=script&lang=js&"
export * from "./newPie.vue?vue&type=script&lang=js&"
import style0 from "./newPie.vue?vue&type=style&index=0&id=d22971e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22971e2",
  null
  
)

export default component.exports